import styled from 'styled-components'
import { color } from 'ui/themes/utils'

const Overdue = styled.div`
  margin-top: 15px !important;
  color: ${color('Accent6/Base')};
  line-height: 1.2rem;
  i {
    margin-right: 5px;
  }
`

export default Overdue
